import script from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts"

import "./CollectionCard.vue?vue&type=style&index=0&id=8ed9bf88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed9bf88"]])

export default __exports__